( function ( _s ) {
	_s.fn.learnDashCourseGrid = function () {
		return this.each( el => {
			const _self = _s( el );
			const _items = _self.find( '.items-wrapper > .item' );

			_items.each( item => {
				const _item = _s( item );
				const _itemTitle = _item.find( '.entry-title' );
				const _courseLink = _itemTitle.find( 'a' );
				const courseLinkURL = _courseLink.attr( 'href' );
				const courseTitle = _courseLink.text();

				if ( courseLinkURL ) {
					_courseLink.replaceWith( courseTitle );
					_itemTitle.text( courseTitle );
					_item
						.find( '> *' )
						.wrapAll( `<a href="${ courseLinkURL }" class="course-link"></a>` );

					_item.find( 'a:not(.course-link)' ).each( link => {
						const _link = _s( link );
						const linkContent = _link.html();

						_link.replaceWith( linkContent );
					} );
				}
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '.learndash-course-grid' ).learnDashCourseGrid();
	} );
} )( window._s );
